import BaseRepository from "@/services/resources/repository";

class Repository extends BaseRepository {
    static make(model, schema) {
        return new Repository(model, schema);
    }

    byCategory(category) {
        return this.try(this.baseQuery().where('category', category).get().then(collection => {
            if (collection.length) {
                return this.format(collection)[category];
            }

            return collection;
        }));
    }

    categorised() {
        return this.try(this.baseQuery().get().then(collection => {
            return this.format(collection);
        }));
    }

    format(collection) {
        const ob = {};

        collection.forEach(record => {
            if (typeof ob[record.category] === 'undefined') {
                ob[record.category] = {};
            }

            ob[record.category][record.title] = record.value;
        });

        return ob;
    }
}

export default Repository;
